import { useEffect, useState } from "react";
import { API_BASE_URL } from "../../lib/api";

interface AuthWrapperProps {
  children: React.ReactNode;
}

export const AuthWrapper = ({ children }: AuthWrapperProps) => {
  const [user, setUser] = useState<any | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        // API_BASE_URL を使用するように修正
        const response = await fetch(`${API_BASE_URL}/auth/me`, {
          headers: {
            // Cloudflare Access の認証情報はクッキーで自動送信されます
          }
        });

        if (response.ok) {
          const userData = await response.json();
          setUser(userData);
        } else if (response.status === 401 || response.status === 403) {
          // 未認証
          setUser(null);
        } else {
          setError("認証チェックに失敗しました");
        }
      } catch (err) {
        console.error("Auth check error:", err);
        setError("サーバーに接続できませんでした");
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-900 text-white">
        <div className="text-xl">認証中...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-900 text-white p-4">
        <div className="bg-red-900/50 border border-red-500 p-6 rounded-lg max-w-md w-full">
          <h2 className="text-xl font-bold mb-4">エラー</h2>
          <p>{error}</p>
          <button 
            onClick={() => window.location.reload()}
            className="mt-4 px-4 py-2 bg-red-600 hover:bg-red-700 rounded transition-colors"
          >
            再読み込み
          </button>
        </div>
      </div>
    );
  }

  if (!user) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-900 text-white p-4">
        <div className="bg-gray-800 p-8 rounded-xl shadow-2xl max-w-md w-full text-center border border-gray-700">
          <h1 className="text-2xl font-bold mb-6">アクセス制限</h1>
          <p className="text-gray-400 mb-8">
            このページにアクセスするにはログインが必要です。<br/>
            Cloudflare Accessの認証を完了してください。
          </p>
          <button 
            onClick={() => window.location.reload()}
            className="w-full py-3 bg-blue-600 hover:bg-blue-700 rounded-lg font-bold transition-all"
          >
            ログインページへ
          </button>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

